import React from 'react'

import { GoogleDocsContext } from './googleDocsContext'

export const wrapPageElement = ({ element, props }) => {
    return <GoogleDocsContext.Provider value={{ ...props.pageContext }}>{element}</GoogleDocsContext.Provider>
}
